import { render } from "./NewForums.vue?vue&type=template&id=768ade62&scoped=true"
import script from "./NewForums.vue?vue&type=script&lang=js"
export * from "./NewForums.vue?vue&type=script&lang=js"

import "./NewForums.vue?vue&type=style&index=0&id=768ade62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768ade62"]])

export default __exports__